export default __webpack_public_path__ + "static/media/profile_pic.f02ad0f2.png";